import React from 'react';
import AdminClients from '../admin/AdminClients';

export default function SalesClientSearch() {
  // Use AdminClients component directly for sales team
  return <AdminClients />;
}